export function AtomBlock({ newData }) {
  return <><sup className="atomicNumber"> {newData.atomicNumber}</sup>
    <span className="symbol">{newData.symbol}</span><sub> {newData.name}</sub>
    <div id={newData.atomicNumber} className="fulldetail" style={{ zIndex: '100', position: 'absolute', left: '0', right: '0', backgroundColor: 'white' }}>
      <div><h3 style={{ textAlign: 'center' }}>{newData.name}</h3>
        <p><strong>Atomic mass:</strong> {newData.atomicMass}</p>
        <p><strong>Atomic number:</strong> {newData.atomicNumber}</p>
        <p><strong>Atomic Radius:</strong> {newData.atomicRadius ? `${newData.atomicRadius} pm` : 'N/A'}</p>
        <p><strong>Boiling Point:</strong> {newData.boilingPoint ? `${newData.boilingPoint} K` : 'N/A'}</p>
        <p><strong>Melting Point:</strong> {newData.meltingPoint ? `${newData.meltingPoint} K` : 'N/A'}</p>
        <p><strong>Density:</strong> {newData.density ? `${newData.density} Kg/L` : 'N/A'}</p>
        <p><strong> Bonding Type:</strong> {newData.bondingType ? newData.bondingType : 'N/A'}</p>
        <p><strong>Oxidation State:</strong> {newData.oxidationStates ? newData.oxidationStates : 'N/A'}</p>
        <p><strong>Vander Waals Radius:</strong> {newData.vanDelWaalsRadius ? `${newData.vanDelWaalsRadius} pm` : 'N/A'}</p>
        <p><strong>Electron Configuration:</strong> {newData.electronicConfiguration ? newData.electronicConfiguration : 'N/A'}</p>
        <p><strong>Ionization Energy:</strong> {newData.ionizationEnergy ? `${newData.ionizationEnergy} kJ/mol` : 'N/A'}</p>
        <p><strong>Electronegativity:</strong> {newData.electronegativity ? newData.electronegativity : 'N/A'}</p>
        <p><strong>Electron Affinity:</strong> {newData.electronAffinity ? newData.electronAffinity : 'N/A'}</p>
        <p><strong>Group Block:</strong> {newData.groupBlock ? newData.groupBlock : 'N/A'}</p>
        <p><strong>Year Discovered:</strong> {newData.yearDiscovered ? newData.yearDiscovered : 'N/A'}</p>
        </div>
    </div>
  </>;
}
